<template>
  <v-container fluid class="season-model-info">
    <v-row>
      <v-col cols="3">
        <v-select
          v-model="supplier"
          :items="
            (choices.suppliers || []).map((row) => ({
              value: row.id,
              text: row.name,
            }))
          "
          label="Toimittaja"
          dense
          hide-details="auto"
        >
        </v-select>
      </v-col>
      <v-col cols="3">
        <!-- The seasons this supplier has actually ordered, not every season
             in the catalog: the list comes from the supplier's own orders. -->
        <v-select
          v-model="season"
          :items="seasonItems"
          :disabled="!supplier"
          :loading="seasonsLoading"
          :no-data-text="
            supplier ? 'Toimittajalla ei ole tilauksia.' : 'Valitse toimittaja.'
          "
          label="Sesonki"
          dense
          hide-details="auto"
        >
        </v-select>
      </v-col>
      <v-col cols="3">
        <v-text-field
          v-model="search"
          label="Hae mallinumerolla"
          dense
          clearable
          hide-details="auto"
        >
        </v-text-field>
      </v-col>
      <v-col cols="3" class="d-flex align-center">
        <span v-if="supplier && season">{{ rows.length }} mallinumeroa</span>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-alert v-if="error" type="error" dense>{{ error }}</v-alert>
        <p v-else-if="supplier && !seasonsLoading && !seasons.length">
          Toimittajalla ei ole yhtään tilausta, joten sesonkeja ei ole.
        </p>
        <p v-else-if="!supplier || !season">Valitse toimittaja ja sesonki.</p>
        <v-data-table
          v-else
          :headers="columns"
          :items="rows"
          :search="search"
          :loading="loading"
          :items-per-page="50"
          :footer-props="{ 'items-per-page-options': [50, 100, -1] }"
          dense
        >
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ChoicesOrderVue from "../mixins/ChoicesOrder.vue";

export default {
  name: "SeasonModelInfo",
  mixins: [ChoicesOrderVue],
  data: function () {
    return {
      loading: false,
      seasonsLoading: false,
      error: null,
      supplier: null,
      season: null,
      search: "",
      rows: [],
      seasons: [],
      columns: [
        {
          text: "Mallinumero",
          value: "modelnumber",
        },
        {
          text: "Extra-sesonki",
          value: "extra_season.code",
        },
        {
          text: "Extra-sesongin nimi",
          value: "extra_season.name",
        },
        {
          text: "Hintakatalogi",
          value: "price_catalog",
        },
        {
          text: "Tilaus",
          value: "order_id",
        },
        {
          text: "Tilauksen tila",
          value: "order_state",
        },
      ],
    };
  },

  computed: {
    seasonItems() {
      // The order count says which season is the live one -- season codes are
      // moving data and the newest is not always the one being worked on.
      return this.seasons.map((row) => ({
        value: row.season,
        text:
          row.order_count === 1
            ? row.season + " (1 tilaus)"
            : row.season + " (" + row.order_count + " tilausta)",
      }));
    },
  },

  methods: {
    fetchSeasons() {
      if (!this.supplier) {
        this.seasons = [];
        this.season = null;
        return;
      }
      const params = new URLSearchParams();
      params.append("supplier", this.supplier);
      this.seasonsLoading = true;
      this.error = null;
      // Same endpoint as the listing below; leaving the season out asks which
      // seasons this supplier has, newest ordered first.
      this.axios
        .get("/api/products/season_model_info/?" + params.toString())
        .then((resp) => {
          this.seasons = resp.data.seasons;
          const has = this.seasons.some((row) => row.season === this.season);
          if (this.season && !has) {
            // The new supplier has never ordered the season that was picked.
            this.season = null;
          }
        })
        .catch((err) => {
          this.error =
            (err.response && err.response.data && err.response.data.error) ||
            "Sesonkien haku epäonnistui.";
          this.seasons = [];
          this.season = null;
        })
        .finally(() => {
          this.seasonsLoading = false;
        });
    },

    fetchRows() {
      if (!this.supplier || !this.season) {
        this.rows = [];
        return;
      }
      const params = new URLSearchParams();
      params.append("supplier", this.supplier);
      params.append("season", this.season);
      this.loading = true;
      this.error = null;
      this.axios
        .get("/api/products/season_model_info/?" + params.toString())
        .then((resp) => {
          this.rows = resp.data.map((row) => ({
            ...row,
            // Tells apart the fallback case: every order for this model
            // number is still a draft.
            order_state: row.is_draft ? "Luonnos" : "Tilattu",
          }));
        })
        .catch((err) => {
          this.error =
            (err.response && err.response.data && err.response.data.error) ||
            "Tietojen haku epäonnistui.";
          this.rows = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },

  watch: {
    supplier() {
      this.fetchSeasons();
      this.fetchRows();
    },
    season() {
      this.fetchRows();
    },
  },
};
</script>
